import { useState } from 'react';
import { InfoFiles } from '../../../../services/journey.service';
import { useGetFileDownloadUrlMutation, useLogSelectedFileMutation } from '../../../../services/file.service';
import FileItemModel from './model';

export default function FileItemViewModel({ file }: { file: InfoFiles }) {
  const [getDownloadUrl] = useGetFileDownloadUrlMutation();
  const [logFile] = useLogSelectedFileMutation();
  const [isLoading, setIsLoading] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);

  const handleDownload = async () => {
    if (isLoading) return;
    logFile(file.id).unwrap().catch(console.error);
    setIsLoading(true);
    try {
      const blob: Blob = await getDownloadUrl({ id: file.id, force: true }).unwrap();
      const fileBlob = new Blob([blob], { type: 'application/octet-stream' });
      const objectUrl = URL.createObjectURL(fileBlob);
      try {
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = `${FileItemModel.getNameWithExtension(file.url)}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } finally {
        URL.revokeObjectURL(objectUrl);
      }
      setShowFeedback(true);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseFeedback = () => setShowFeedback(false);

  return {
    isLoading,
    handleDownload,
    showFeedback,
    handleCloseFeedback,
    displayName: FileItemModel.truncateFileName(file.name)
  };
}
